import moment from 'moment';

export const defaultYearMonth: YearMonthFields = {
  year: -1,
  month: -1,
};

export interface YearMonthFields {
  year: number;
  month: number;
}

export const createYearMonth = (timestamp: number): YearMonthFields => {
  const momentObj = moment(timestamp);
  return {
    year: momentObj.year(),
    month: momentObj.month() + 1,
  };
};
